<template>
  <div class="base-plan-card">
    <div class="header">{{ title }}</div>
    <div class="pricing">
      <div class="price">{{ price === 0 ? 'Free' : '$' + price }}</div>
      <div class="interval" v-if="interval">billed {{ interval }}</div>
    </div>
    <div class="content">
      <div class="feature" :class="{ plus: feature === 'Plus' }" v-for="(feature, i) in features" :key="i">{{ feature }}</div>
      <BaseButton class="button" :text="cta" :theme="disabled ? 'disabled' : 'purple'" :loading="loading" @click.native="handleSelected" />
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton/BaseButton'
export default {
  components: {
    BaseButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    interval: {
      type: String,
      required: false
    },
    features: {
      type: Array,
      required: true
    },
    cta: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    async handleSelected() {
      this.loading = true
      this.$emit('selected')
    }
  }
}
</script>

<style lang="scss" scoped>
.base-plan-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: var(--border-1);
  border-radius: var(--br-1);
  background: var(--color-white-1);
  overflow: hidden;
  text-align: center;
}
.header,
.pricing {
  width: 100%;
  padding: var(--spacing-4);
  color: var(--color-black-1);
  background: var(--color-gray-2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: var(--border-1);
}
.pricing {
  height: 94px;
}
.header {
  font-size: var(--fs-subtitle);
}
.price {
  color: var(--color-black-1);
  font-weight: var(--fw-medium);
  font-size: var(--fs-title);
  margin-bottom: var(--spacing-1);
}
.interval {
  color: var(--color-gray-3);
}
.content {
  display: grid;
  grid-auto-flow: row;
  align-items: center;
  padding: var(--spacing-4);
  grid-gap: var(--spacing-4);
}
.feature {
  color: var(--color-gray-3);
}
.feature.plus {
  color: var(--color-black-1);
  font-weight: var(--fw-medium);
  font-style: italic;
}
.button {
  margin-top: 5rem;
  justify-self: center;
}
</style>
